<template>
  <div class="container">
    <h3 class="font-weight-medium mb-5 text-center">
      Vamos gerar uma nova senha para seu acesso ao aplicativo
    </h3>
    <property-value property="E-mail" :value="tokenData.mail" class="mb-5" />
    <v-form ref="form" @submit="submit">
      <v-text-field
        v-model="password"
        type="password"
        outlined
        label="Nova senha"
        :rules="[$rules.required, $rules.minLengthPassword]"
        autocomplete="new-password"
        maxlength="16"
      />
      <v-text-field
        v-model="confirmPassword"
        class="mt-3"
        type="password"
        :rules="[equalsPasswords]"
        outlined
        label="Confirme a nova senha"
        autocomplete="new-password"
        maxlength="16"
      />
      <div class="d-flex justify-center mt-3">
        <v-btn block large color="secondary" type="submit">
          Salvar
          <v-icon class="ml-3">send</v-icon>
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import {
  decodeTokenForgotPassword,
  resetPassword,
} from "@/services/external/users-service";

export default {
  name: "ResetPassword",
  data: () => ({
    tokenData: {},
    password: "",
    confirmPassword: "",
    token: "",
  }),
  computed: {
    equalsPasswords() {
      return (
        this.password === this.confirmPassword || "Senhas precisam ser iguais"
      );
    },
  },
  created() {
    if (this.$route.query.t) {
      this.token = this.$route.query.t;
      this.loadTokenData();
    } else {
      this.$router.push("auth.login");
    }
  },
  methods: {
    async loadTokenData() {
      try {
        this.$store.dispatch("loading/openDialog");
        const { data } = await decodeTokenForgotPassword(this.token);
        this.tokenData = data;
      } catch (error) {
        this.$errorHandler(error);
        this.$router.push({ name: "auth.login" });
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    async submit(event) {
      event.preventDefault();
      if (!this.$refs.form.validate()) return;
      try {
        this.$store.dispatch("loading/openDialog");
        await resetPassword({
          token: this.token,
          password: this.password,
          confirmPassword: this.confirmPassword,
        });
        this.$toasted.global.success({
          message: "Senha alterada com sucesso!",
        });
        this.$router.push({ name: "auth.login" });
      } catch (e) {
        this.$errorHandler(e);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
  },
};
</script>

<style scoped></style>
